/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const UpRightArrow = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M1.71429 16C1.24286 16 0.839286 15.8321 0.503571 15.4964C0.167857 15.1607 0 14.7571 0 14.2857V1.71429C0 1.24286 0.167857 0.839286 0.503571 0.503572C0.839286 0.167858 1.24286 0 1.71429 0H8V1.71429H1.71429V14.2857H14.2857V8H16V14.2857C16 14.7571 15.8321 15.1607 15.4964 15.4964C15.1607 15.8321 14.7571 16 14.2857 16H1.71429ZM5.78571 11.4286L4.57143 10.2143L13.0714 1.71429H10.2857V0H16V5.71429H14.2857V2.92857L5.78571 11.4286Z"
        fill="#FFF"
      />
    </BaseSvgIcon>
  )
}

export default UpRightArrow
